import { useNavigate } from "react-router-dom";

export function PublicFooter() {
  const navigate = useNavigate();

  return (
    <footer className="sa-public-footer">
      <div className="sa-public-footer__copy">
        © {new Date().getFullYear()} SubmitterAI - Answers from the Quran alone.
      </div>
      <div className="sa-public-footer__links">
        <a onClick={() => navigate("/about")} style={{ cursor: "pointer" }}>
          About
        </a>
        <a
          href="https://github.com/saji2000/SubmitterAI"
          target="_blank"
          rel="noreferrer"
          style={{ cursor: "pointer" }}
        >
          GitHub
        </a>
      </div>
    </footer>
  );
}
